/* eslint-disable import/prefer-default-export */
import { contactUsJson } from './contactUSJson';

export const actionConfig = {
  contactUs: {
    title: 'Contact ',
    buttonText: 'Contact Us',
    actionButtonSaveText: 'Send',
    actionButtonCancelText: 'Cancel',
    jsonConfig: contactUsJson,
  },
};
